import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Producto/generarExcel`, method: 'POST', body: list, token: token})
}